"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const reducer_1 = require("../../reducer");
const actions = __importStar(require("../actions"));
const components_2 = require("../components");
const SignReceiptForm_1 = __importDefault(require("../forms/SignReceiptForm"));
const reducer_2 = require("../reducer");
const GoBack_1 = __importDefault(require("./GoBack"));
function SignReceipt({ currentLocation, getSalesReceipt, paymentDetails, lenderSettings, processedSale, selectedPlan, signReceipt, setPaymentDetails, }) {
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    // State
    const [localSelectedPlan, setLocalSelectedPlan] = (0, react_1.useState)();
    const [localProcessedSale, setLocalProcessedSale] = (0, react_1.useState)();
    const [localPaymentDetails, setLocalPaymentDetails] = (0, react_1.useState)();
    const [showGoBack, setShowGoBack] = (0, react_1.useState)(false);
    const [showNewDealModalForSigner, setShowNewDealModalForSigner] = (0, react_1.useState)(false);
    const [showNewDealModalForNonSigner, setShowNewDealModalForNonSigner] = (0, react_1.useState)(false);
    const [showAuthorizedSignerModal, setShowAuthorizedSignerModal] = (0, react_1.useState)(false);
    const [shouldScrollToBottom, setShouldScrollToBottom] = (0, react_1.useState)(false);
    const [showMissingIDExpirationModal, setShowMissingIDExpirationModal] = (0, react_1.useState)(false);
    const [submissionFromModal, setSubmissionFromModal] = (0, react_1.useState)('');
    const [shownMissingIDExpirationModal, setShownMissingIDExpirationModal] = (0, react_1.useState)(false);
    const { data: globalConfig } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1FeatureFlagsGlobalQuery)();
    const globalConfigFix = globalConfig;
    const { isCurrentLocationManagerSigner, needsToSignNewDealTerms } = currentLocation ?? {};
    const featureFlags = globalConfigFix?.featureFlags;
    (0, react_1.useEffect)(() => {
        if (isCurrentLocationManagerSigner &&
            needsToSignNewDealTerms &&
            featureFlags &&
            featureFlags.newDealPostGoLive) {
            setShowNewDealModalForSigner(true);
        }
        else if (!isCurrentLocationManagerSigner &&
            needsToSignNewDealTerms &&
            featureFlags &&
            featureFlags.newDealPostGoLive) {
            setShowNewDealModalForNonSigner(true);
        }
    }, [currentLocation]);
    (0, react_1.useEffect)(() => {
        if (processedSale) {
            setLocalProcessedSale(processedSale);
        }
    }, [processedSale]);
    (0, react_1.useEffect)(() => {
        if (paymentDetails) {
            setLocalPaymentDetails(paymentDetails);
        }
    }, [paymentDetails]);
    (0, react_1.useEffect)(() => {
        if (selectedPlan) {
            setLocalSelectedPlan(selectedPlan);
        }
        if (selectedPlan === undefined) {
            setShowGoBack(true);
        }
    }, [selectedPlan]);
    const handleSubmit = (0, react_1.useCallback)((formValues) => {
        const signReceiptRequest = {
            transactionId: processedSale.transactionId,
        };
        const { idExpiration } = formValues;
        if (idExpiration) {
            const idExpiration = (0, utils_1.formatISODateString)(formValues.idExpiration);
            signReceiptRequest.idExpirationDate = idExpiration;
        }
        return signReceipt(signReceiptRequest).then(() => {
            return getSalesReceipt(processedSale.transactionId);
        });
    }, [processedSale]);
    const handleSubmitSuccess = (pdfWindowURL) => {
        (0, utils_1.windowOpenAndPrint)(pdfWindowURL); // Print
    };
    const handleVoidSales = (0, react_1.useCallback)(() => {
        const { name, alphaeonAccountNumber, creditLimit, amount, referenceId, buyer, } = paymentDetails;
        const { createdAt, locationName, transactionId } = processedSale;
        const { name: selectedPlanName } = selectedPlan;
        history.push({
            pathname: `${config_1.VOID_SALE_URL}${alphaeonAccountNumber}`,
            state: {
                transaction: {
                    amount,
                    createdAt,
                    locationName,
                    planName: selectedPlanName,
                    transactionId,
                },
                alphaeonAccountNumber,
                creditLimit,
                name,
                referenceId,
                buyer,
            },
        });
    }, [paymentDetails, processedSale, selectedPlan]);
    (0, react_1.useEffect)(() => {
        if (!showNewDealModalForSigner && shouldScrollToBottom) {
            window.scrollTo(0, document.body.scrollHeight);
            setShouldScrollToBottom(false);
        }
    }, [showNewDealModalForSigner, shouldScrollToBottom]);
    const setIdExpirationForPaymentDetails = (0, react_1.useCallback)((idExpiration) => {
        const paymentDetailsUpdated = {
            ...paymentDetails,
            identificationConfirmation: {
                ...paymentDetails.identificationConfirmation,
                expirationDate: idExpiration,
            },
        };
        setPaymentDetails(paymentDetailsUpdated);
        if (localPaymentDetails) {
            setLocalPaymentDetails(paymentDetailsUpdated);
        }
    }, []);
    if (localPaymentDetails && localProcessedSale && localSelectedPlan) {
        const { name, alphaeonAccountNumber, creditLimit, amount, referenceId, buyer, availableCreditLimit, ssnLast4, authorizationCode, identificationConfirmation, accountMemberId, } = localPaymentDetails;
        const { name: selectedPlanName, terms } = localSelectedPlan;
        const { transactionId, contractSignatureUrl, daysUntilAuthExpiration } = localProcessedSale;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "account-lookup m-t-30", children: [showAuthorizedSignerModal && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizedSignerModal, { isOpen: showAuthorizedSignerModal, setIsOpen: setShowAuthorizedSignerModal })), showNewDealModalForSigner && ((0, jsx_runtime_1.jsx)(components_2.NewDealSignerModal, { isOpen: showNewDealModalForSigner, setIsOpen: setShowNewDealModalForSigner, setShouldScrollToBottom: setShouldScrollToBottom })), showNewDealModalForNonSigner && ((0, jsx_runtime_1.jsx)(components_2.NewDealNonSignerModal, { isOpen: showNewDealModalForNonSigner, setIsOpen: setShowNewDealModalForNonSigner, currentLocation: currentLocation, setShowAuthorizedSignerModal: setShowAuthorizedSignerModal, setShouldScrollToBottom: setShouldScrollToBottom })), (0, jsx_runtime_1.jsx)(components_2.MissingIDExpirationDateModal, { idType: (0, utils_1.getIdentityTypeName)(identificationConfirmation.type), setIsOpen: setShowMissingIDExpirationModal, isOpen: showMissingIDExpirationModal, printReceipt: handleSubmitSuccess, onSubmitFail: utils_1.flashSubmitFailure, setExpirationDate: setIdExpirationForPaymentDetails, setSubmissionFromModal: setSubmissionFromModal, setShownMissingIDExpirationModal: setShownMissingIDExpirationModal }), (0, jsx_runtime_1.jsx)(components_1.H1, { children: "Sign Receipt, Step 3 of 3" }), (0, jsx_runtime_1.jsxs)("div", { className: "account-summary summary refund-complete", children: [(0, jsx_runtime_1.jsx)(components_1.ReceiptAccountInfo, { buyer: buyer, paymentDetails: paymentDetails, lenderSettings: lenderSettings, currentLocation: currentLocation, name: name, alphaeonAccountNumber: alphaeonAccountNumber, availableCreditLimit: availableCreditLimit, ssnLast4: ssnLast4, creditLimit: creditLimit, amount: amount, authorizationCode: authorizationCode, referenceId: referenceId }), (0, jsx_runtime_1.jsxs)("div", { className: "sales-complete-container", id: "print-container", children: [(0, jsx_runtime_1.jsx)(components_1.ReceiptDisplay, { buyer: buyer, name: name, lenderSettings: lenderSettings, currentLocation: currentLocation, selectedPlanName: selectedPlanName, authorizationCode: authorizationCode, alphaeonAccountNumber: alphaeonAccountNumber, isContractSignature: !!contractSignatureUrl, terms: terms, amount: amount }), processedSale && ((0, jsx_runtime_1.jsx)(SignReceiptForm_1.default, { voidSale: handleVoidSales, initialValues: {
                                            type: (0, utils_1.getIdentityTypeName)(identificationConfirmation.type),
                                            state: identificationConfirmation.state,
                                            idExpiration: identificationConfirmation.expirationDate,
                                        }, idExpirationUpdated: identificationConfirmation.expirationDate, alphaeonAccountNumber: alphaeonAccountNumber, contractSignatureUrl: contractSignatureUrl, buyerId: accountMemberId, currentLocation: currentLocation.locationId, onSubmit: handleSubmit, onSubmitSuccess: handleSubmitSuccess, onSubmitFail: utils_1.flashSubmitFailure, transactionId: transactionId, status: processedSale.status, isCurrentLocationManagerSigner: isCurrentLocationManagerSigner, idType: identificationConfirmation.type, daysUntilAuthExpiration: daysUntilAuthExpiration, setShowMissingIDExpirationModal: setShowMissingIDExpirationModal, shownMissingIDExpirationModal: shownMissingIDExpirationModal, submissionFromModal: submissionFromModal }))] })] })] }) }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", { children: showGoBack ? (0, jsx_runtime_1.jsx)(GoBack_1.default, { distance: -3 }) : (0, jsx_runtime_1.jsx)("div", { children: "...Loading Page" }) }));
    }
}
function mapStateToProps(state) {
    return {
        paymentDetails: reducer_2.selectors.paymentDetails(state),
        lenderSettings: reducer_2.selectors.lenderSettings(state),
        processedSale: reducer_2.selectors.processedSale(state),
        selectedPlan: reducer_2.selectors.selectedPlan(state),
        currentLocation: reducer_1.selectors.currentLocation(state),
    };
}
const mapDispatchToProps = {
    setPaymentDetails: actions.setPaymentDetails,
};
const mapApiAuthToProps = {
    getSalesReceipt: apiActions.getSalesReceipt,
    searchForAccounts: apiActions.searchForAccounts,
    signReceipt: apiActions.signReceipt,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(SignReceipt);
